import React from 'react';
import PropTypes from 'prop-types';
import AppInfoHeader from '../AppInfoHeader';
import FunctionTabs from '../FunctionTabs';
import RightManagement from '../RightManagement';
import { Route } from 'react-router-dom';

class Management extends React.Component {
	state = {
	};

	render () {
		const { match } = this.props;

		const rightManagementProps = {
			showDepartmentScope: false,
			showProjectScope: false,
		};

		return (
			<div>
				<AppInfoHeader />
				<FunctionTabs
					routes={[
						{ name: '权限管理', path: `${match.url}/authority` },
					]}
				/>
				<Route
					exact
					path={`${match.url}/authority`}
					render={props => <RightManagement {...props} {...rightManagementProps} />}
				/>
			</div>
		);
	}
}

Management.childContextTypes = {
	payload: PropTypes.object
};

export default Management;
